// extracted by mini-css-extract-plugin
export var banner = "_26-0";
export var icon = "_26-1";
export var message = "_26-2";